import React, { useState } from "react";
import { AxiosResponse } from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { postRequest } from "../../utils/httpRequest";

const LoginForm = ({ initialEmail = "", setError }) => {
  const [submiting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const initialValues = {
    email: initialEmail,
    password: "",
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (values) => {
    setSubmitting(true);
    setError("");

    postRequest("/session/email.json", {
      session: {
        email: values.email,
        password: values.password,
        login: true,
        react_session: true,
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;

        (window as any).location = data.url || "/profile";
      })
      .catch((error) => {
        setSubmitting(false);
        setError(error.response.data?.errors);
      });
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid }) => (
        <Form className="ui form">
          <Field type="hidden" name="email" />
          <div>
            <div className="field">
              <div className="ui icon action input">
                <Field
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className={`pwd-toggle ${showPassword ? "is-shown" : ""}`}
                  onClick={() => toggleShowPassword()}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg
                      className="icon-show"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  ) : (
                    <svg
                      className="icon-hide"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  )}
                </button>
              </div>
              <ErrorMessage
                name="password"
                component="div"
                className="ui red pointing above label error"
              />
            </div>
          </div>
          <div className="ui one column grid center aligned forgot-password">
            <a id="forgot-password" href="/session/password_resets/new">
              Forgot password?
            </a>
          </div>
          <div className="action">
            <button
              type="submit"
              className={`ui button ${submiting ? "loading" : ""}`}
              disabled={!isValid || submiting}
            >
              Continue
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
